import {rqCreateSearchRequest} from './rqHttpsUtils';
import {RQ_GET_SCHEDULER_HISTORY_BY_DATE_API, RQ_GET_SCHEDULER_LOG_DETAILS_API} from './constants';
import {useQuery} from '@tanstack/react-query';

export const RQGetSchedulerLogByDate = payload => {
  return useQuery(
    ['rq_get_scheduler_log_by_date', payload],
    async ({queryKey, signal}) => {
      const {token, logDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_SCHEDULER_HISTORY_BY_DATE_API,
        null,
        token,
        {logDate: logDate},
        signal,
        null,
      );
    },
    {
      cacheTime: 0,
    },
  );
};

export const RQGetSchedulerLogDetails = payload => {
  return useQuery(
    ['rq_get_scheduler_log_details', payload],
    async ({queryKey, signal}) => {
      const {token, logId, logType} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_SCHEDULER_LOG_DETAILS_API,
        null,
        token,
        {logId: logId, logType: logType},
        signal,
        null,
      );
    },
    {
      cacheTime: 0,
    },
  );
};
